export const TAX_FREE_NA_COUNTRY = 'es'
export const TAX_FREE_NA_LABEL = 'N/A'

export function resolveTaxFreeLabel ({
  country,
  taxFreeLabel,
}: {
  country?: string | null
  taxFreeLabel: string
}): string {
  if (country === TAX_FREE_NA_COUNTRY) {
    return TAX_FREE_NA_LABEL
  }

  return taxFreeLabel
}

export function resolveSpanishMatrixNullTaxLabel ({
  country,
  exemptMedicalLabel,
  taxFreeLabel,
}: {
  country?: string | null
  exemptMedicalLabel: string
  taxFreeLabel: string
}): string {
  if (String(country || '').toLowerCase() === TAX_FREE_NA_COUNTRY) {
    return exemptMedicalLabel
  }

  return resolveTaxFreeLabel({ country, taxFreeLabel })
}
